export default "__VITE_ASSET__BqkW41Mq__"